export const USER_CHANGE_TEXT = 'USER_CHANGE_TEXT';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_ERROR = 'AUTH_USER_ERROR';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

export const FC_CHANGE_TEXT = 'FC_CHANGE_TEXT';
